package one.devsbox.www.ui.locations

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import compose.assets.Svg
import compose.assets.svg.Plus
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.www_portal.generated.resources.*
import tk.mallumo.compose.navigation.navTo_LocationDUI
import tk.mallumo.compose.navigation.navTo_LocationEUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class ListingLocationVM : NavigationViewModel() {

    var search by mutableStateOf(TextFieldState())

    private lateinit var ctx: ListingLocationCtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    var locationState by mutableStateOf<DataState<SharedIO.Locations>>(DataState.Loading())
        private set

    val locationDetails = mutableStateMapOf<Long, SharedIO.Location>()

    interface Action {
        fun reloadLocations()
        fun fetchLocationDetails(id: Long)
        fun openDetail(id: Long)
        fun newLocation()
        fun back()
    }

    val action = object : Action {
        override fun newLocation() {
            ctx.nav.navTo_LocationEUI()
        }

        override fun reloadLocations() {
            loadLocations()
        }

        override fun fetchLocationDetails(id: Long) {
            scope.launch {
                runCatching {
                    val details = Repository.ads.location.get(id)
                    locationDetails[id] = details
                }
            }
        }

        override fun openDetail(id: Long) {
            ctx.nav.navTo_LocationDUI(ArgsId(id))
        }

        override fun back() {
            ctx.nav.up()
        }
    }

    fun setup(ctx: ListingLocationCtx) {
        this.ctx = ctx
        loadLocations()
    }

    private fun loadLocations() {
        locationState = DataState.Loading()
        scope.launch {
            runCatching {
                Repository.ads.location.listing(0)
            }.onSuccess {
                locationState = DataState.Result(it)
                setupActions()
            }.onFailure {
                locationState = DataState.Error(it.message ?: "Unknown error")
                contentActions = emptyList()
            }
        }
    }

    private fun setupActions() {
        contentActions = buildList {
            if (ctx.me.permission.location.write && !ctx.me.info.adminMode) {
                add(
                    ScreenContentAction(
                        text = Res.string.ui_locations_listing_btn_new,
                        color = ctx.colorPrimaryContainer,
                        icon = Svg.Plus
                    ) {
                        action.newLocation()
                    }
                )
            }
        }
    }

    override fun onRelease() {}
}


